import { render, staticRenderFns } from "./userInfo.vue?vue&type=template&id=ef98d1d8&scoped=true&"
import script from "./userInfo.vue?vue&type=script&lang=js&"
export * from "./userInfo.vue?vue&type=script&lang=js&"
import style0 from "./userInfo.vue?vue&type=style&index=0&id=ef98d1d8&lang=stylus&scoped=true&"
import style1 from "./userInfo.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef98d1d8",
  null
  
)

export default component.exports